import * as $ from "jquery";
import "bootstrap";
import { bookingFormCommon } from '../c005-bookingform-common';

export class SaveCard {
	$scope: any = $("#saveCardContainer");
	$totalnumberCards: any = $('[data-total-cards-count]').attr('data-total-cards-count');
	removePopupFlag: boolean = false;
	private bookingformcommon = new bookingFormCommon();
	formateCardRegex: RegExp = /(\d{4})(?=\d)/g;
	trimSpaceRegex: RegExp = /\s/g;
	deleteSuccessPopup = false;
	private addCard: any = null;
	private errorMessageArr = [
		{ key: 'Network', message: "Oops, the connection was lost. Please refresh your page to try again." },
		{ key: 'SessionTimeout', message: "Transaction session has been timed out. Please refresh your page to try again." },
		{ key: 'PaymentError', message: "There was a Payment Error. Please try again." },
		{ key: 'Canceled', message: "Transaction Cancelled by User​." },
		{ key: 'Unexpected', message: "There was an unexpected error during transaction. Please try again." },
	];
	init(): any {
		let _self = this;
		_self.$scope
			.find("#total-card-count")
			.html(this.$totalnumberCards)
			.text();
	}

	getCookie(name: string): any {
		var value = "; " + document.cookie;
		var parts = value.split("; " + name + "=");
		var cookieVal: any;
		if (parts.length == 2) {
			cookieVal = parts.pop().split(";").shift();
			return cookieVal;
		}
	}

	// api call to get saved cards
	getCardList() {
		let _self = this;
		let cookieAccessToken = _self.getCookie("sapphire");
		if (cookieAccessToken && cookieAccessToken !== "undefined") {
			// this if case is for working with json in local setup
			if (location.host == "localhost:5000") {
				$.ajax({
					type: "GET",
					url: "http://localhost:5000/dummy-data/cardList.JSON",
					contentType: "application/json",
					success: function (data: any) {
						_self.displayCards(data);
					},
					error: function (error: any) { },
				});
			} else {
				// actual api call to get saved cards
				$.ajax({
					type: "GET",
					url: "/bin/services/new/getCardDetailsAPI",
					contentType: "application/json",
					success: function (data: any) {
						_self.displayCards(data);
					},
					error: function (error: any) { },
				});
			}
		}
		else {
			window.location.href = $('#enrichLoginURLSaveCard').val();
		}
	}

	// inject cards detail to page dynamicaly
	displayCards(response: any): void {
		let _self = this;
		let $cardList: any = "";
		if (response.paymentCardsDetails.length > 0) {
			_self.$scope.find(".card-main-content").removeClass("hideclass");
			_self.$scope.find(".empty-card-main").addClass("hideclass");
			_self.$scope.find(".card-main-content").empty();
			const cardItem = response.paymentCardsDetails;
			//set saved cards count
			_self.$scope
				.find("#curr-count")
				.html(response.paymentCardsDetails.length)
				.text();
			//create node for saved cards dynamically
			cardItem.forEach((item: any, index: number) => {
				const formatedCard = item.displayCardNumber
					? `**** **** **** ${item.displayCardNumber.slice(-4)}`
					: "";
				const expDate = item.expiryDate
					? item.expiryDate.replace(/(\d{2})(\d{2})/, "$1/$2")
					: "";
				const isExpired = this.isExpired(item, expDate);
				var windowSize = $(window).width();
				if ((windowSize >= 719)) {
					$cardList += `   
				<div class="col-sm-6 col-xs-12 col-md-4 col-lg-4 mb-65">
					<div class="saved-card disableForExpired-${isExpired}" id="saved-card">
						<div class="card-container-wrapper card-container-${item.vendorCode}">
							<div class="card-content">
								<div class="card-header-details">
									<div class="card-type-wrapper">
										<div class="card-type card-type-${item.vendorCode}"></div>
										<span class="expiredDateLabel-${isExpired}"> Expired</span>
									</div>
									<div class="delete-btn-wrapper">
										<input type='hidden' value='${item.id}' name='cardId'/>
										<button class="btn-delete remove-card" aria-label="Delete"><img src="/content/dam/mas/enrich-tokenization/trash-can.png" alt="Delete Icon"/></button>
									</div>
								</div>
								<div class="chip-icon"></div>
								<div class="card-font card-16px-font  card-number">${formatedCard}</div>
								<div class="card-footer-details  card-font  card-14px-font ">
									<div class=" card-owner">${item.holderName}</div>
									<div class="card-date"><span class="expiry">${expDate}</span></div>
								</div>
							</div>
						</div>
							<label class="default-card-selector expiredDateLabel-${isExpired} expDefaulter-${item.isDefault}">
							<input class="default-card-selector-checkbox" type="checkbox" id='${item.id}' ${item.isDefault && !isExpired ? 'checked' : null} ${isExpired ? 'disabled' : ''} />
							<div class="default-card-selector-switch  pointer-no-drop-${isExpired}"></div><span class="default-card-selector-label card-font card-font card-14px-font">set as default payment</span>
							</label>
							<span class="defaulter-${item.isDefault}"> DEFAULT</span>
					</div>
				</div>        
					`;
				} else {
					$cardList += `   
					<div class="col-sm-6 col-xs-12 col-md-4 col-lg-4 mb-65">
						<div class="saved-card" id="saved-card">
							<div class="card-container-wrapper card-container-${item.vendorCode}">
								<div class="card-content">
									<div class="card-header-details">
										<div class="card-type-wrapper">
											<span class="defaulter-mob-${item.isDefault}"> DEFAULT</span>
											<span class="expiredDateLabel-${isExpired}"> Expired</span>
										</div>
									</div>
									<div class="chip-icon"></div>
									<div class="cardname-no col-sm-12 col-xs-12 col-md-12">
										<div class="card-type col-xs-3 card-type-${item.vendorCode}"></div>
										<div class="card-font card-16px-font  card-number col-xs-7 col-md-5 col-sm-5">${formatedCard}</div>
										<div class="delete-btn-wrapper">
											<input type='hidden' value='${item.id}' name='cardId'/>
											<button class="btn-delete col-xs-2 remove-card remove-card-formobile" aria-label="Delete"><i class="fa fa-angle-right" aria-hidden="true"></i></button>
										</div>
		
									</div>
									<div class="card-footer-details card-font card-14px-font">
										<div class="card-date">Expiry date &nbsp<span class="expiry">${expDate}</span></div>
									</div>
								</div>
							</div>
						</div>
					</div>        
						`;
				}
				// <label class="default-card-selector">
				// <input class="default-card-selector-checkbox" type="checkbox" id='${item.id}' ${item.isDefault && !isExpired ? 'checked' : null} ${isExpired ? 'disabled' : ''} />
				// <div class="default-card-selector-switch  pointer-no-drop-${isExpired}"></div><span class="default-card-selector-label card-font card-font card-14px-font">set as default payment</span>
				// </label>
				if (item.isDefault && isExpired) {
					$(".expired-card-notification").removeClass('hideclass');
					_self.$scope
						.find("#expired-card-type")
						.html(item.vendorCode);
					_self.$scope
						.find("#expired-card-num")
						.html(item.displayCardNumber.slice(-4));
					// _self.$scope
					// .find(".forcard-number")
					// .html(item.displayCardNumber.slice(-4));
				}
			});
			// appent div for add card option
			response.paymentCardsDetails.length < this.$totalnumberCards ? $cardList += `
			<div class="col-sm-6 col-xs-12 col-md-4 col-lg-4 mb-65">
				<div id="new_add-card_btn" class="add-card-box new-add-card-btn cursor-pointer">
				   <img src="/content/dam/mas/enrich-tokenization/addcardIcon.png">
                    <p>Add card</p>
				</div>			
			</div>
				`: null;
			_self.$scope.find(".card-main-content").append($cardList);
			// default transaction card details content showing onload
			// const card = cardItem.find((ls: any) => ls.isDefault);
			// _self.$scope
			// 	.find("#default-card-type")
			// 	.html(card.vendorCode);
			// _self.$scope
			// 	.find("#default-card-num")
			// 	.html(card.displayCardNumber.slice(-4));
			// default trasanction toggle function call
			_self.toggleDefautCard(cardItem);
			//register add card button click
			_self.onAddCardClick();

		}
		else {
			// toggle add card design when there is no saved cards
			_self.$scope.find(".empty-card-main").removeClass("hideclass");
			_self.$scope.find(".card-main-content").addClass("hideclass");
			$(".default-card-notification").addClass('hideclass');
			$(".expired-card-notification").addClass('hideclass');
			_self.$scope
				.find("#curr-count")
				.html(response.paymentCardsDetails.length)
				.text();
		}

		//register remove card button click
		_self.removeCardClick(response);


	}
	isExpired(item: any, expiredDate: any) {
		let _self = this;
		let currentDate = new Date();
		let currentYear: any = currentDate.getFullYear().toString().substr(-2);
		let currentMonth = currentDate.getMonth() + 1; // Adding 1 because months are zero-based (January is 0).
		let cardExpirationArray = expiredDate.split("/");
		let cardExpirationMonth = parseInt(cardExpirationArray[0], 10);
		let cardExpirationYear = parseInt(cardExpirationArray[1], 10);

		if ((cardExpirationYear < currentYear || (cardExpirationYear == currentYear && cardExpirationMonth < currentMonth))) {

			return true;
		} else {

			return false;
		}

	}
	removeCardClick(response: any): void {
		let _self = this;
		const cardItem = response.paymentCardsDetails;
		$(".remove-card, .remove-card-formobile").on("click", function (event: Event) {
			//let _self = this;
			$(".card-number-formobile").html("");
			$(".card-holdername").html("");
			$(".card-expdate").html("");
			$(".detial-toggle").children("label:first").remove();
			var windowSize = $(window).width();
			if ((windowSize >= 719)) {
				let cookieAccessToken = _self.getCookie("sapphire");
				if (cookieAccessToken && cookieAccessToken !== "undefined") {
					const id = $(this).parent().find('input[type="hidden"]').val();
					$('#remove-success-popup').addClass('hideclass');
					$(".delete-item-container").removeClass('hideclass');
					$(".delete-item-container-formobile").removeClass('hideclass');
					$.magnificPopup.open({
						items: {
							src: "#removecard-popup",
						},
						type: "inline",
						midClick: true,
						enableEscapeKey: false,
						callbacks: {
							open: function () {
								let $content = $(this.content);
								$('.cancel-btn').on('click', function () {
									$.magnificPopup.close();
								});
								$content.off("click").on("click", '.remove-btn', function () {

									const formData = new FormData();
									formData.append('id', id);
									formData.append('action', 'delete');


									if (location.host == "localhost:5000") {

										$(".delete-item-container").addClass('hideclass');
										$(".delete-item-container-formobile").addClass('hideclass');
										$('#remove-success-popup').removeClass('hideclass');
										$('#remove-success-popup-formob').addClass('hideclass');
										setTimeout(function () {
											$.magnificPopup.close();
										}, 2000);

									} else {
										// actual api call to get delete cards						
										$.ajax({
											type: "POST",
											url: "/bin/services/new/updateEnrichUserCardDetails",
											data: formData,
											processData: false,
											contentType: false,
											success: function (json: any) {
												$(".delete-item-container").addClass('hideclass');
												$(".delete-item-container-formobile").addClass('hideclass');
												$('#remove-success-popup').removeClass('hideclass');
												$('#remove-success-popup-formob').addClass('hideclass');
												setTimeout(function () {
													$.magnificPopup.close();
												}, 2000);
												_self.getCardList();
											},
											error: function (error: any) {
												console.log("Error while submitting card details" + error);
											},
										});
									}
								});
							},
							close: function () {
								$('#remove-success-popup').addClass('hideclass');
								$(".delete-item-container").addClass('hideclass');
								$(".delete-item-container-formobile").addClass('hideclass');
								$('#remove-success-popup-formob').addClass('hideclass');
							}
						},
					});
				}
				else {
					window.location.href = $('#enrichLoginURLSaveCard').val();
				}
			 } 
			else {
				const cardId = $(this).parent().find('input[type="hidden"]').val();
				cardItem.forEach((item: any, index: number) => {
					let clickedId = item.id;
					if (cardId == clickedId) {
						const formatedCard1 = item.displayCardNumber
							? `**** **** **** ${item.displayCardNumber.slice(-4)}`
							: "";
						const expDate1 = item.expiryDate
							? item.expiryDate.replace(/(\d{2})(\d{2})/, "$1/$2")
							: "";
						const isExpired = _self.isExpired(item, expDate1);
						$(".card-number-formobile").append(formatedCard1);
						$(".card-holdername").append(item.holderName);
						$(".card-expdate").append(expDate1);
						$(".detial-toggle").append(`<label class="default-card-selector">
							<input class="default-card-selector-checkbox" type="checkbox" id='${item.id}' ${item.isDefault && !isExpired ? 'checked' : null} ${isExpired ? 'disabled' : ''} />
							<div class="default-card-selector-switch  pointer-no-drop-${isExpired}"></div><span class="default-card-selector-label card-font card-font card-14px-font">Set card as default payment for next payment</span>
							</label>`)
					}
				});
				//set saved cards count
				//create node for saved cards dynamically

				var div = $(this).parent("div");
				var _class = div.attr("class");
				//let cardNo = $(this).find("card-number").text();
				let cookieAccessToken = _self.getCookie("sapphire");
				if (cookieAccessToken && cookieAccessToken !== "undefined") {
					//const id = $(_self).parent().find('input[type="hidden"]').val();
					//$(this).closest('fieldset').find('.plotNumber').val();
					$('#remove-success-popup').addClass('hideclass');
					$(".delete-item-container").removeClass('hideclass');
					$(".delete-item-container-formobile").removeClass('hideclass');
					$.magnificPopup.open({
						items: {
							src: "#removecard-popup-formobile",
						},
						type: "inline",
						midClick: true,
						enableEscapeKey: false,
						callbacks: {
							open: function () {
								let $content = $(this.content);
								$('.cancel-btn').on('click', function () {
									$.magnificPopup.close();
								});
								$content.off("click").on("click", '.remove-btn', function () {
									
									const formData = new FormData();
									formData.append('id', cardId);
									formData.append('action', 'delete');


									if (location.host == "localhost:5000") {
										$(".delete-item-container").addClass('hideclass');
										$('#remove-success-popup-formob').removeClass('hideclass');
										$(".delete-item-container-formobile").addClass('hideclass');
										$('#remove-success-popup').addClass('hideclass');
										setTimeout(function () {
											$.magnificPopup.close();
										}, 2000);

									} else {
										// actual api call to get delete cards						
										$.ajax({
											type: "POST",
											url: "/bin/services/new/updateEnrichUserCardDetails",
											data: formData,
											processData: false,
											contentType: false,
											success: function (json: any) {
												$(".delete-item-container").addClass('hideclass');
												$(".delete-item-container-formobile").addClass('hideclass');
												$('#remove-success-popup-formob').removeClass('hideclass');
												$('#remove-success-popup').addClass('hideclass');
												setTimeout(function () {
													$.magnificPopup.close();
												}, 2000);
												_self.getCardList();
											},
											error: function (error: any) {
												console.log("Error while submitting card details" + error);
											},
										});
									}
								});
							},
							close: function () {
								$('#remove-success-popup').addClass('hideclass');
								$(".delete-item-container").addClass('hideclass');
								$(".delete-item-container-formobile").addClass('hideclass');
							}
						},
					});
				}
				else {
					window.location.href = $('#enrichLoginURLSaveCard').val();
				}
			}
		});
	}
	// cardDetailView(response: any): void {
	// 	let _self = this;
	// 	const cardItem = response.paymentCardsDetails;
	// 	//set saved cards count
	// 	//create node for saved cards dynamically
	// 	cardItem.forEach((item: any, index: number) => {

	// 	})
	// }
	onAddCardClick() {
		let _self = this;
		$(".add-card-box").on("click", function () {
			let cookieAccessToken = _self.getCookie("sapphire");
			if (cookieAccessToken && cookieAccessToken !== "undefined") {
				_self.bookingformcommon.preloader();
				$('#save-success-popup').addClass('hideclass');
				$('#save-error-popup').addClass('hideclass');
				$(".save-card-container").removeClass('hideclass');
				let ppidUrl: any;
				let formData = _self.extractFormDataSaveCard();
				formData.action = "add-card";
				if (location.host == "localhost:5000") {
					ppidUrl = "http://localhost:5000/dummy-data/addCardPPID.JSON";
				} else {
					ppidUrl = "/bin/services/new/updateEnrichUserCardDetails";
				}
				$.ajax({
					type: 'POST',
					url: ppidUrl,
					data: $.param(formData),
					success: function (data: any) {
						_self.bookingformcommon.preloaderClose();
						let json: any = null;
						if (typeof data === 'string') {
							json = JSON.parse(data);
						} else {
							json = data;
						}
						if (json.processStatus === "OK" && json.ppid !== undefined) {
							$('#saveCardPPID').val(json.ppid);
							_self.checkAndLoadAmadeusSDK(json.ppid);

						} else {
							if (json.processMessage) {
								$('.payment-error').addClass('showclass');
								$('.payment-error').removeClass('hideclass');
								$('.payment-error').html(json.processMessage);
							} else {
								$('.payment-error').addClass('showclass');
								$('.payment-error').removeClass('hideclass');
								//$('.payment-error').html('Unable to proceed, please try again.');
							}
						}

					}, error: function (error: any) {
						_self.bookingformcommon.preloaderClose();
						console.log(error);
						$('.payment-error').addClass('showclass');
						$('.payment-error').removeClass('hideclass');
						//$('.payment-error').html = "Something went wrong. Please try again.";
					}
				});
			}
			else {
				window.location.href = $('#enrichLoginURLSaveCard').val();
			}

		});

	}
	// function to get input field values from popup
	extractFormData() {
		return {
			cardNumber: $("#card-number").val().replaceAll(' ', ''),
			holderName: $("#card-holder").val(),
			expiryDate: $("#card-expiry").val(),
			isDefault: $("#default-card").is(":checked"),
			action: "",
		};
	}
	extractFormDataSaveCard() {
		return {
			action: "",
		};
	}
	// clear popup input fields
	clearForm() {
		$("#card-number").val("");
		$("#card-holder").val("");
		$("#card-expiry").val("");
		$("#default-card").attr("checked", false);
		$("#card-type-icon").removeClass();
		$("#card-type-icon").addClass("icon icon-default");
		$("#saveBtn").attr("disabled", true);
	}
	// to validate card number (card type & max,min length)
	validateCardNumber(cardNumber: string) {
		const amexRegex = /^3[47][0-9]{0,13}$/;
		const jcbRegex = /^(352[89]|35[3-8][0-9])[0-9]{0,12}$/;
		const mastercardRegex = /^5[1-5][0-9]{0,14}$/;
		const visaRegex = /^4[0-9]{0,15}$/;
		let rtnVal: any = { type: undefined, valid: false };
		if (amexRegex.test(cardNumber)) {
			rtnVal = { type: "AX", valid: !(cardNumber.length != 15) };
		} else if (jcbRegex.test(cardNumber)) {
			rtnVal = { type: "JCB", valid: !(cardNumber.length != 16) };
		} else if (mastercardRegex.test(cardNumber)) {
			rtnVal = { type: "MC", valid: !(cardNumber.length != 16) };
		} else if (visaRegex.test(cardNumber)) {
			rtnVal = {
				type: "VI",
				valid: cardNumber.length >= 13 && cardNumber.length <= 16,
			};
		}
		return rtnVal;
	}

	// onSaveCard() {
	// 	let _self = this;
	// 	$("#saveBtn").click(function (event: Event) {
	// 		event.preventDefault();
	// 		let formData = _self.extractFormData();
	// 		if (formData) {
	// 			formData.action = "save";
	// 			console.log(formData);
	// 			_self.clearForm();
	// 			if (location.host == "localhost:5000") {
	// 				$.magnificPopup.proto.close.call(this);
	// 				$.magnificPopup.instance.close = function () {
	// 					_self.openSuccessPopup();
	// 				};
	// 			} else {
	// 				$.ajax({
	// 					type: "POST",
	// 					url: "/bin/services/new/enrichUserCardDetails",
	// 					data: $.param(formData),
	// 					success: function (json: any) {
	// 						_self.clearForm();
	// 						$.magnificPopup.proto.close.call(this);
	// 						$.magnificPopup.instance.close = function () {
	// 							_self.openSuccessPopup();
	// 						};
	// 					},
	// 					error: function (error: any) {
	// 						console.log("Error while submitting card details" + error);
	// 					},
	// 				});
	// 			}
	// 		} else {
	// 			console.log("Form is not valid.");
	// 		}
	// 	});
	// }

	validateForm() {
		let _self = this;
		let cardIput = $("#card-number");
		let cardExpIput = $("#card-expiry");
		let cardHolder = $("#card-holder");
		let isValidCard: boolean = false;
		let isValidName: boolean = false;
		let isValidExp: boolean = false;
		cardIput.on("input", function () {
			let cardNumber = $(this).val().replace(_self.trimSpaceRegex, ""); // Remove existing spaces
			let formattedNumber = "";
			cardNumber = cardNumber.replace(/[^0-9]/g, "");
			let cardType = _self.validateCardNumber(cardNumber);
			if (cardType.type) {
				$("#card-type-icon").removeClass("icon-default");
				$("#card-type-icon").addClass(`icon-${cardType.type}`);
			} else {
				$("#card-type-icon").removeClass();
				$("#card-type-icon").addClass("icon icon-default");
			}
			formattedNumber = cardNumber.replace(_self.formateCardRegex, "$1 ");
			cardIput.val(formattedNumber);
			if (cardType.valid) {
				isValidCard = true;
				_self.clearErrorMessage(cardIput);
			} else {
				isValidCard = false;
				_self.showErrorMessage(cardIput);
			}
			//function call to enable or disable save button
			_self.toggleSaveBtn(isValidCard && isValidExp && isValidName);
		});

		cardExpIput.on("input", function () {
			let inputVal = $(this).val().replace(_self.trimSpaceRegex, "");
			inputVal = inputVal.replace(/[^0-9]/g, "").slice(0, 4);
			let formattedDate = "";
			if (inputVal.length > 2) {
				formattedDate = inputVal.slice(0, 2) + "/" + inputVal.slice(2);
			} else {
				formattedDate = inputVal;
			}
			let currentDate = new Date();
			let currentMonth = currentDate.getMonth() + 1; // Month starts with zero in js
			let currentYear = currentDate.getFullYear() % 100; // Get last two digits of the year
			let parts = formattedDate.split("/");
			let inputMonth = parseInt(parts[0]);
			let inputYear = parseInt(parts[1]);
			if (
				!inputMonth ||
				!inputYear ||
				inputMonth < 1 ||
				inputMonth > 12 ||
				inputYear < currentYear ||
				(inputYear === currentYear && inputMonth < currentMonth)
			) {
				isValidExp = false;
				_self.showErrorMessage(cardExpIput);
			} else {
				isValidExp = true;
				_self.clearErrorMessage(cardExpIput);
			}
			//function call to enable or disable save button
			_self.toggleSaveBtn(isValidCard && isValidExp && isValidName);
			cardExpIput.val(formattedDate);
		});
		cardHolder.on("input", function () {
			let inputVal = $(this).val().trim();
			cardHolder.val(inputVal.toUpperCase());
			if (inputVal.length < 3 || inputVal.length > 40) {
				_self.showErrorMessage(cardHolder);
				isValidName = false;
			} else {
				_self.clearErrorMessage(cardHolder);
				isValidName = true;
			}
			//function call to enable or disable save button
			_self.toggleSaveBtn(isValidCard && isValidExp && isValidName);
		});
	}

	toggleSaveBtn(isValid: boolean): void {
		isValid
			? $("#saveBtn").attr("disabled", false)
			: $("#saveBtn").attr("disabled", true);
	}

	showErrorMessage(input: any) {
		const errorId = input.attr("id") + "-err";
		$(`#${errorId}`).removeClass("hide");
		input.data("valid", false);
	}

	clearErrorMessage(input: any) {
		const errorId = input.attr("id") + "-err";
		input.data("valid", true);
		$(`#${errorId}`).addClass("hide");
	}
	toggleDefautCard(cardItem: any) {
		let _self = this;

		_self.$scope
			.find(".default-card-selector")
			.on("click", ".default-card-selector-checkbox", function (evt: any) {
				let cookieAccessToken = _self.getCookie("sapphire");
				if (cookieAccessToken && cookieAccessToken !== "undefined") {
					const id = $(this).prop("id");
					const card = cardItem.find((ls: any) => ls.id == id);

					if ($(this).prop("checked")) {
						if (location.host == "localhost:5000") {

							$(".default-card-selector-checkbox").not(this).prop("checked", false);
							$(".default-card-notification").removeClass('hideclass');
							$(".expired-card-notification").addClass('hideclass');
							_self.$scope
								.find("#default-card-type")
								.html(card.vendorCode);
							_self.$scope
								.find("#default-card-num")
								.html(card.displayCardNumber.slice(-4));
							const formData: any = {
								id: id, action: "setDefault",
								isDefault: "true"
							};
							$.ajax({
								type: "POST",
								url: "/bin/services/new/updateEnrichUserCardDetails",
								data: $.param(formData),
								success: function (json: any) {
									_self.getCardList();
								},
								error: function (error: any) {
									$(this).prop("checked", false);
									// $(".default-card-notification").addClass('hideclass');
									// console.log("Error while submitting card details" + error);
								},
							});
						}
						else {
							$(".default-card-selector-checkbox").not(this).prop("checked", false);
							$(".default-card-notification").removeClass('hideclass');
							$(".expired-card-notification").addClass('hideclass');
							_self.$scope
								.find("#default-card-type")
								.html(card.vendorCode);
							_self.$scope
								.find("#default-card-num")
								.html(card.displayCardNumber.slice(-4));
							const formData: any = {
								id: id, action: "setDefault",
								isDefault: "true"
							};
							$.ajax({
								type: "POST",
								url: "/bin/services/new/updateEnrichUserCardDetails",
								data: $.param(formData),
								success: function (json: any) {
									_self.getCardList();
								},
								error: function (error: any) {
									$(this).prop("checked", false);
									$(".default-card-notification").addClass('hideclass');
									$(".expired-card-notification").addClass('hideclass');
									console.log("Error while submitting card details" + error);
								},
							});
						}

					}
					else {
						if (location.host == "localhost:5000") {

							$(".default-card-selector-checkbox").not(this).prop("checked", false);
							$(".default-card-notification").addClass('hideclass');
							$(".expired-card-notification").addClass('hideclass');
							const formData: any = {
								id: id, action: "unsetDefault",
								isDefault: "false"
							};
							$.ajax({
								type: "POST",
								url: "/bin/services/new/updateEnrichUserCardDetails",
								data: $.param(formData),
								success: function (json: any) {
									_self.getCardList();
								},
								error: function (error: any) {
									$(this).prop("checked", false);
									// $(".default-card-notification").addClass('hideclass');
									// console.log("Error while submitting card details" + error);
								},
							});
						}
						else {
							$(".default-card-selector-checkbox").not(this).prop("checked", false);
							$(".default-card-notification").addClass('hideclass');
							$(".expired-card-notification").addClass('hideclass');
							const formData: any = {
								id: id, action: "unsetDefault",
								isDefault: "false"
							};
							$.ajax({
								type: "POST",
								url: "/bin/services/new/updateEnrichUserCardDetails",
								data: $.param(formData),
								success: function (json: any) {
									_self.getCardList();
								},
								error: function (error: any) {
									$(this).prop("checked", false);
									$(".default-card-notification").addClass('hideclass');
									$(".expired-card-notification").addClass('hideclass');
									console.log("Error while submitting card details" + error);
								},
							});
						}
					}
				}
				else {
					window.location.href = $('#enrichLoginURLSaveCard').val();
				}
			});
		$(".notification-close-button").click(function (event: Event) {
			$(".default-card-notification").addClass('hideclass');
		});
		$(".expired-notification-close-btn").click(function (event: Event) {
			$(".expired-card-notification").addClass('hideclass');
		});
	}
	initializeCheckoutSDk(ppid: any): any {
		let self = this;
		const environment = $('#environment').val();
		var SDKConfiguration = {
			container: 'addcard-form-container',
			ppid: ppid,
			environment: environment,
			locale: 'en',
			options: {
				mopSelectionInSdk: false,
				showVendor: false,//After Chaging Here, need to be updated in AEM as well
				collectCardholderName: true,
				collectCardExpiryDate: true,
				displayPlaceholders: true,
				showSecurityHelper: false
			}
		}
		self.addCard = new window.AmadeusCheckout(SDKConfiguration);
		self.addCard.onReady = function (mopsList: any, sessionTimeout: any) {
			console.log("onReady", mopsList, sessionTimeout);
			if (!this.isError) {
				self.loadMOPS(mopsList);
				this.isReady = true;
				self.addCard.selectMop('creditcard');
			}
			$.magnificPopup.open({
				items: {
					src: "#addcard-popup",
				},
				type: "inline",
				midClick: false,
				enableEscapeKey: false,
				callbacks: {
					afterClose: function () {
						$('#save-success-popup').addClass('hideclass');
						$('#save-error-popup').addClass('hideclass');
						$(".save-card-container").addClass('hideclass');
						self.getCardList();
					}
				},
			});

		}

		self.addCard.onChange = function (change: any) {
			$('.save-btn').prop('disabled', !change.isValid);
		}
		// self.addCard.onRedirectionNeeded = function(mopId: any, redirectionRequest: any) {
		//     // Called before the SDK redirects the user to an external page
		//     console.log("onRedirectionNeeded", mopId, redirectionRequest);
		//     this.isRedirecting = true;
		// }
		self.addCard.onSuccess = function (mopId: any) {
			// Called when the payment is successful
			console.log("onSuccess", mopId);
			let saveTokenUrl: any;
			const savecardID = $('#saveCardPPID').val();
			const formData = { ppid: savecardID, action: "save" };
			if (location.host == "localhost:5000") {
				saveTokenUrl = "http://localhost:5000/dummy-data/saveCardToken.JSON";
			} else {
				saveTokenUrl = "/bin/services/new/updateEnrichUserCardDetails";
			}
			$.ajax({
				type: 'POST',
				url: saveTokenUrl,
				data: $.param(formData),
				success: function (data: any) {
					let json: any = null;
					if (typeof data === 'string') {
						json = JSON.parse(data);
					} else {
						json = data;
					}
					if (json.processStatus === "OK") {
						$('#save-success-popup .success-text-section p').html(json.processMessage);
						$('#save-success-popup').removeClass('hideclass');
						$(".save-card-container").addClass('hideclass');
						$('#save-error-popup').addClass('hideclass');
					}
					else {
						if (json.processMessage) {
							$('#save-success-popup').addClass('hideclass');
							$(".save-card-container").addClass('hideclass');
							$('#save-error-popup .error-text-section p').html(json.processMessage);
							$('#save-error-popup').removeClass('hideclass');
						}
						else {
							$('#save-success-popup').addClass('hideclass');
							$(".save-card-container").addClass('hideclass');
							$('#save-error-popup').removeClass('hideclass');
						}
					}
					setTimeout(function () {
						$.magnificPopup.close();
					}, 2000);
				},
				error: function (error: any) {
					console.log("Error while submitting card details" + error);
					setTimeout(function () {
						$.magnificPopup.close();
					}, 2000);
				},
			});
			$(".save-card-container").addClass('hideclass');


		}
		self.addCard.onError = function (mopId: any, errorDetails: any) {
			console.log("onError", mopId);
			$('#save-success-popup').addClass('hideclass');
			$(".save-card-container").addClass('hideclass');
			$('#save-error-popup').removeClass('hideclass');
			setTimeout(function () {
				$.magnificPopup.close();
			}, 2000);
			// if(errorDetails.nextAction == "Retry") {
			//     self.loading(true, 'Thank you for your order. We are redirecting you...');
			// } else {
			//     self.loading(true);
			// }           
			// if(errorDetails.nextAction && errorDetails.nextAction == "Retry") {
			//     let errorMessage = self.errorMessageArr.filter((error) => {
			//         return error.key === errorDetails.errorType;
			//     });
			//     self.loading(false);
			//     $('body').addClass("body-class");
			//     $('#enrich-nav-sidebar').addClass('sidebar-none-events');
			//     $('#bookingNav').addClass("sidebar-none-events");
			//     localStorage.setItem('errorMsg', errorMessage[0].message);
			//     $('#payment-status').html(errorMessage[0].message);              
			// }
		}
		$('.save-btn').click(function () {
			self.addCard.pay();
		});

		self.addCard.start();
	}
	checkAmadeusCheckoutIsLoaded() {
		return window && window.AmadeusCheckout;
	}
	checkAndLoadAmadeusSDK(ppid: any) {
		let self = this;
		if (self.checkAmadeusCheckoutIsLoaded()) {
			self.initializeCheckoutSDk(ppid);
		}
		else {
			setTimeout(function () {
				self.checkAmadeusCheckoutIsLoaded();
				self.initializeCheckoutSDk(ppid);
			}, 1000);
		}
	}
	loading(isLoading: any, text: any = null) {
		text = text === null ? 'Thank you for your order. We are redirecting you...' : text;
		console.log(isLoading);
		if (isLoading) {
			$('.loader-desc').html(text);
			$('#overlay').fadeIn();
			$('.content').addClass('hideclass');
			$('.content').removeClass('showclass');
			$('.footer').addClass('hideclass');
			$('.footer').removeClass('showclass');
			$('#overlay').addClass('showclass');
			$('#overlay').removeClass('hideclass');
		} else {
			$('#overlay').fadeOut();
			$('.footer').addClass('showclass');
			$('.footer').removeClass('hideclass');
			$('.content').addClass('showclass');
			$('.content').removeClass('hideclass');
			$('#overlay').addClass('hideclass');
			$('#overlay').removeClass('showclass');
		}
	}
	loadMOPS(mopsList: any) {
		// load creditcard form

		let self = this;
		for (var mop of mopsList) {
			var name = mop.name;
			var id = mop.id;
			var icon_url = this.addCard.getIconUrl('amop', mop.name);
			console.log(icon_url);
			switch (name) {
				case "label_mop_creditcard":
					this.addCard.create('addcard-form-container', id);
					break;
				default:
					break;
			}
		}

	}
}


let scope: Element = document.querySelector("#saveCardContainer");
declare const window: any;

if (scope) {
	try {
		let saveCard = new SaveCard();
		saveCard.init();
		saveCard.getCardList();

		$(document).ready(function () {
			saveCard.onAddCardClick();
		});
	} catch (e) {
		/*console.error(e); */
	}
}